import {useState, useEffect} from 'react'
import { CiCircleCheck } from "react-icons/ci";


export const Colors = ({colors, active, handleColors}) => {
    
    useEffect( ()=> {

    }, [])

    const chooseColor = (color) => {
        color = color.toLowerCase()
        switch (color) {
            case 'rojo': return { color: '#ff0000' };
            case 'azul': return { color: '#0000ff' };
            case 'verde': return { color: '#00ff00' };
            case 'blanco': return { color: '#f4f4f4' };
            case 'negro': return { color: '#000000' };
            case 'cafe': return { color: '#A18262' };
            case 'naranja': return { color: '#FFA500' };
            case 'gris': return { color: '#9B9B9B' };
            default: return { color: '#ffffff' };
        }
    }

    // const getColorSelected = (e) => {
    //     e.preventDefault()
    //     setActiveColor(colors)
    // }

    return (
        <button
            className=' justify-content-center align-items-center'
            style={{
                backgroundColor: chooseColor(colors).color,
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                margin: '0 5px',
                border: active === colors ? '1px solid' : 'none',
                boxShadow: active === colors ? '2px 2px 2px 1px rgba(0, 0, 0, 0.2)' : 'none'
            }}
            onClick={handleColors}
        >
            {
                active === colors && (
                    <CiCircleCheck className='fs-2' color={chooseColor(colors).color.substring(0, 3).concat('EDFA')}  />
                )
            }
        </button>
    )
}
